/* eslint-disable react/button-has-type */
import React from "react";
import { useConfig } from "../../utils/context/configContext";

interface SpecificButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    buttonFunc?: React.MouseEventHandler<HTMLButtonElement>;
    prefix?: string;
    postfixIcon?: React.ReactNode;
    className?: string;
    buttonText?: string;
    btnSecondary?: boolean;
    loading?: boolean;
    disabled?: boolean;
    type?: "button" | "submit" | "reset";
    id?: string;
}

const SpecificButton: React.FC<SpecificButtonProps> = ({
    buttonFunc,
    prefix,
    postfixIcon,
    className = "",
    buttonText,
    btnSecondary,
    loading = false,
    disabled = false,
    type = "button",
    id = "button",
    ...props
}) => {
    const config = useConfig();
    const button = config?.style?.button;
    const priority = button?.priority;

    const background = disabled
        ? (priority?.buttonBackground || button?.buttonDisabledBackground)
        : (btnSecondary ? config?.style?.base?.brandColor : (priority?.buttonBackground || button?.buttonBackground)) || '#000';
    const color = disabled
        ? (priority?.buttonDisabledTextColor || button?.buttonDisabledTextColor)
        : (priority?.buttonTextColor || button?.buttonTextColor) || '#fff';
    const justifyContent = priority?.justify || 'center';
    const padding = priority?.padding || '0 24px';

    return (
        <button
            {...props}
            id={id}
            type={type}
            disabled={disabled}
            onClick={buttonFunc}
            className={`${className} ${"flex min-h-[33px] gap-[5px] border-none cursor-pointer items-center  justify-center [&_svg]:size-[16px] [&_svg]:shrink-0 rounded-[9999px]  min-w-[120px] text-[14px] px-6  disabled:shadow-none   py-[6px]"
                }`}
            style={{
                fontFamily: button?.buttonFontFamily || 'Inter, sans-serif',
                fontSize: button?.buttonFontSize || '14px',
                background,
                color,
                fontWeight: button?.buttonFontFamily || 'normal',
                pointerEvents: disabled ? 'none' : 'auto',
                borderRadius: button?.buttonBorderRadius || '9999px',
                justifyContent,
                padding,
            }}
        >
            {prefix && <img className="w-[20px] h-[20px]" src={prefix} alt="icon" />}
            {buttonText}
            {postfixIcon && postfixIcon}
            {/* {loading && disabled && <CircularProgress size={15} />} */}
        </button>
    );
};

export default SpecificButton;
